export const adminMenuOptions = [
  {
    url: "/dashboard/admin/deliveries",
    text: "Deliveries",
  },
  {
    url: "/dashboard/admin/harvest-for-business",
    text: "Business Inventory",
  },
  {
    url: "/dashboard/admin/orders",
    text: "Orders",
  },
  {
    url: "/dashboard/admin/manage-users",
    text: "Manage Users",
  },
  {
    url: "/dashboard/admin/harvest-log",
    text: "Harvest Log",
  },
  {
    url: "/dashboard/admin/pickup-locations",
    text: "Pickup Locations",
  },
  {
    url: "/dashboard/admin/csa-subscriptions",
    text: "CSA Subscriptions",
  },
  {
    url: "/dashboard/admin/event-info",
    text: "Event Checklist",
  },
  {
    url: "/dashboard/admin/operation-controls",
    text: "Operation Controls",
  },
];
export const employeeMenuOptions = [
  {
    url: "/dashboard/employee/deliveries",
    text: "Deliveries",
  },
  {
    url: "/dashboard/employee/harvest-for-business",
    text: "Business Inventory",
  },
  {
    url: "/dashboard/employee/orders",
    text: "Orders",
  },
  {
    url: "/dashboard/employee/harvest-log",
    text: "Harvest Log",
  },
];
